export const statusStyles = {
  ACTIVE: "bg-green-700 text-white border-green-700",
  INACTIVE: "bg-red-500 text-white border-red-600",
};

export const statusDotStyles = {
  ACTIVE: "bg-green-500",
  INACTIVE: "bg-red-500",
};

export const positionStyles = {
  Seller: "bg-blue-50 text-blue-700 border-blue-200",
  "Shop Manager": "bg-orange-50 text-orange-700 border-orange-200",
  "Shop Owner": "bg-purple-50 text-purple-700 border-purple-200",
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    " " + date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};